module.exports = __webpack_public_path__ + "img/ring_y_o_0_1.e5961bb9.png";